import { createFileRoute } from "@tanstack/react-router";
import { FeriadosEditarPage } from "@/paginas/pg_feriados/feriados-editar";

export const Route = createFileRoute("/_authenticated/sistema-feriados-editar")({
  head: () => ({
    meta: [{ title: "Editar feriado — Milky Moo Palmares" }],
  }),
  component: FeriadosEditarPage,
});
